export const isStackholderDashboardUrl = (location: { pathname: string }) =>
  location.pathname.includes('adm/pv/')
